import { selectedClubId } from '../state/club-session';
/** Store only a digest and UUID; invitation tokens and monetary terms never enter storage. */
export async function intentKey(kind:string, terms:unknown):Promise<{key:string;complete:()=>void}> {
  const bytes = new TextEncoder().encode(JSON.stringify([selectedClubId(),kind,terms]));
  const digest = [...new Uint8Array(await crypto.subtle.digest('SHA-256',bytes))].map(b=>b.toString(16).padStart(2,'0')).join('');
  const storageKey=`lom.intent.${digest}`;
  let key=sessionStorage.getItem(storageKey);
  if(!key) {key=crypto.randomUUID();sessionStorage.setItem(storageKey,key);}
  return {key,complete:()=>sessionStorage.removeItem(storageKey)};
}
